import { useState } from "react";
import { Images } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { COLS } from "@/components/VideoGallery";
import { PhotoGallery } from "@/components/PhotoGallery";
import { fileUrl } from "@/lib/api";

const coverOf = (a) => a.cover || a.photos?.[0]?.url || "";

// Named photo albums ("Easter 2026"): a grid of covers; clicking one opens that album's photos in a large popup.
export const PhotoAlbums = ({ id, albums, cols = 4 }) => {
  const [open, setOpen] = useState(null);
  const list = (Array.isArray(albums) ? albums : []).filter((a) => a?.photos?.length);
  if (!list.length) return null;
  return (
    <>
      <ul data-testid={`albums-${id}`} data-cols={COLS[cols] ? cols : 4} className={`grid grid-cols-2 gap-x-4 gap-y-7 ${COLS[cols] || COLS[4]}`}>
        {list.map((a, i) => (
          <li key={a.id}>
            <button type="button" data-testid={`albums-${id}-item-${i}`} onClick={() => setOpen(a)} aria-label={`Open album ${a.title || i + 1}`} className="group block w-full text-left">
              <span className="relative block aspect-[4/3] w-full overflow-hidden rounded-2xl bg-[#131C2E]">
                <img src={fileUrl(coverOf(a))} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute bottom-2.5 right-2.5 flex items-center gap-1 rounded-full px-2.5 py-1 font-ui text-[11px] font-semibold" style={{ backgroundColor: "rgba(11,17,30,0.75)", color: "#FFFFFF" }}>
                  <Images className="h-3.5 w-3.5" /> {a.photos.length}
                </span>
              </span>
              <span data-testid={`albums-${id}-title-${i}`} className="mt-2.5 line-clamp-2 block font-display text-lg font-semibold leading-snug text-[#F4EEE2]">{a.title || "Album"}</span>
              <span className="block font-ui text-xs text-[#B7BFCC]">{a.photos.length} photo{a.photos.length === 1 ? "" : "s"}</span>
            </button>
          </li>
        ))}
      </ul>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent data-testid={`albums-${id}-dialog`} className="max-h-[92vh] w-[94vw] max-w-[1400px] overflow-y-auto p-5 sm:max-w-[1400px] md:p-8">
          <DialogTitle className="font-display text-3xl font-semibold text-[#F4EEE2] md:text-4xl">{open?.title || "Album"}</DialogTitle>
          {open && <div className="mt-4"><PhotoGallery id={`${id}-${open.id}`} items={open.photos} cols={4} /></div>}
        </DialogContent>
      </Dialog>
    </>
  );
};
